import * as yup from "yup";

export const createAddTransactionValidationSchema = (transactionTypes) => {
  const transactionTypeMap = transactionTypes.reduce((acc, type) => {
    acc[type.id] = type.name;
    return acc;
  }, {});

  console.log("transactionTypes: " + JSON.stringify(transactionTypes));
  return yup.object().shape({
    transactionTypeID: yup
      .string()
      .required("Transaction Type is required"),
    amount: yup
      .number()
      .typeError("Amount must be a valid number")
      .positive("Amount must be a positive number")
      .required("Amount is required"),
    notesForBee: yup.string()
    .required('Notes for Admin is required')
    .min(4, 'Notes for Admin must be at least 4 characters'),
    notesForAdmin: yup.string(),
    requestTypeID: yup
      .string()
      .when('transactionTypeID', {
        is: (transactionTypeID) => transactionTypeMap[transactionTypeID] === 'Reward',
        then: yup.string().required('Job Type is required.'),
        otherwise: yup.string().notRequired()
      }),
    linkedStnPurchaseID: yup
      .number()
      .nullable()
      .transform((value, originalValue) => {
        return originalValue === '' ? null : value;
      })
      .typeError('Linked STN Purchase ID must be a valid number')
      .positive('Linked STN Purchase ID must be greater than zero'),
  });
}